<template>
  <div class="date-input-container mb-3">
    <label>
      <question-display :question="question"  customClass="header-date"></question-display>
    </label>
    <input
      type="date"
      v-model="inputValue"
      :placeholder="question.placeholder || ''"
      class="form-control"
      @input="updateInput"
    />
    <small v-if="showValidation && question.required && !inputValue" class="text-danger">This field is required.</small>
  </div>
</template>

<script>
import surveyService from '@/services/surveyService'; // Import the survey service
import QuestionDisplay from '../utils/QuestionDisplay.vue';

export default {
  components: {
      QuestionDisplay
  },
  props: {
    question: Object,
    required: Boolean,
    showValidation: Boolean // Add showValidation prop
  },
  data() {
    let defaultValue = '';
    if (this.question?.default_value) {
      defaultValue = new Date().toISOString().split('T')[0]; // Format date as "YYYY-MM-DD"
    }
    return {
      inputValue: surveyService.getAnswer(this.question.id) || defaultValue
    };
  },
  methods: {
    updateInput() {
      surveyService.setAnswer(this.question.id, this.inputValue); // Save the answer directly through the service
      this.$emit('input', this.inputValue);
    }
  },
  watch: {
    question(newQuestion) {
      let defaultValue = '';
      if (newQuestion?.default_value) {
        defaultValue = new Date().toISOString().split('T')[0]; // Format date as "YYYY-MM-DD"
      }
      this.inputValue = surveyService.getAnswer(newQuestion.id) || defaultValue;
      if (defaultValue) {
        this.updateInput(); // Call updateInput if default value is set
      }
    }
  },
  mounted() {
    if (this.question?.default_value) {
      this.updateInput(); // Call updateInput if default value is set on initial load
    }
  }
};
</script>